import { Chip, ChipProps } from '@mui/material';
import { STEP_STATUS_LABELS, StepStatus } from './stepStatus';

const STATUS_COLORS: Record<StepStatus, ChipProps['color']> = {
  not_started: 'default',
  in_progress: 'warning',
  complete: 'success'
};

export interface StatusChipProps {
  status: StepStatus;
  label?: string;
  variant?: ChipProps['variant'];
}

/** Not Started, In Progress or Complete, as a step, a Discovery section, a milestone or a client's scoring reads. */
export const StatusChip = ({ status, label, variant = 'outlined' }: StatusChipProps) => (
  <Chip
    // Saved data is stored as sent, so a status outside the three still shows as written.
    label={label ?? STEP_STATUS_LABELS[status] ?? status}
    color={STATUS_COLORS[status] ?? 'default'}
    variant={variant}
    size="small"
  />
);
